import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import { FcOpenedFolder } from 'react-icons/fc';

interface IExcelFileDialogProps {
    dialogName: string;
    handleCategories?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
}

const ExcelFileDialog = (props: IExcelFileDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ExcelFileDialog onCreate()');
    };

    // const showDialog = (dialog: DialogList) => {
    //     dispatch(actions.layout.showDialog(dialog));
    // };

    // const hideDialog = () => {
    //     dispatch(actions.layout.hideDialog());
    // };

    // const reports = () => {
    //     showDialog(DialogList.VENDOR_REPORTS);
    // };

    const OKClicked = () => {
        let values = getValues();

        console.log(values);

        props.hideDialog();
    };

    // const buttonClick = () => {
    //     console.log('Button Clicked');
    // };

    return (
        <Dialog title="Excel File" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFInputBox
                        label="Beginning Date"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        name={`excelFile.beginDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem' }}
                    />
                    <RHFInputBox
                        label="Ending Date"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        name={`excelFile.endDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem' }}
                    />
                    <RHFSelect
                        name={`excelFile.vendorType`}
                        label="Vendor Type"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        options={[
                            { value: 'A/P Vendor List', label: 'A/P Vendor List' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem' }}
                    />
                    <RHFSelect
                        name={`excelFile.vendorTaxType`}
                        label="Vendor Tax Type"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        options={[
                            { value: 'Vendor Number', label: 'Vendor Number' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem', marginTop: '1rem' }}
                    />
                    <div className="form-row">
                        <RHFInputBox
                            label="Filename"
                            labelOnLeft={true}
                            labelStyle={{ width: '17rem', margin: '0'}}
                            name={`excelFile.filename`}
                            type="file"
                            register={register}
                            errors={errors}
                            style={{ width: '100%', margin: '0' }}
                            bodyStyle={{ width: '40rem' }}
                        />
                        {/* <Button
                            style={{ height: '3rem', marginBottom: '2rem', background: 'transparent'}}
                            text={''}
                            title="Open File"
                            reactIcon={FcOpenedFolder}
                            iconStyle={{width: '2.5rem', height: '2.5rem'}}
                            onClick={() => buttonClick}
                        /> */}
                    </div>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
                </Dialog>
    );
};

export default ExcelFileDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/ExcelFileDialog.tsx